import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { createTest } from "../../services/api";
import Breadcrumbs from "../../components/BreadCrumbs";

const TestCreate = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [testData, setTestData] = useState({
    nombre: "",
    descripcion: "",
    assignedTo: "",
    estado: "",
    proyectos_id: "",
  });

  const handleChange = (e) => {
    setTestData({
      ...testData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Agrega el proyecto_id al objeto testData
      const dataToSend = {
        ...testData,
        proyectos_id: projectId, // Asegúrate de que este sea el nombre correcto que espera tu API
      };

      await createTest(dataToSend);
      navigate(`/dashboard/projects/${projectId}/tests`);
    } catch (error) {
      console.error("Error al crear el caso de prueba", error);
    }
  };

  // Definir las rutas para los breadcrumbs
  const breadcrumbPaths = [
    { name: "Dashboard", url: "/dashboard" },
    { name: "Projects", url: "/dashboard/projects" },
    { name: "Test", url: "/dashboard/projects/" + projectId + "/tests" },
    {
      name: "Create test",
      url: "/dashboard/projects/" + projectId + "/tests/create",
    },
  ];

  return (
    <>
      <h2>Crear Caso de Prueba</h2>
      <Breadcrumbs paths={breadcrumbPaths} />
      <form onSubmit={handleSubmit}>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">
            Nombre del Caso de Prueba
          </label>
          <div class="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="nombre"
              value={testData.nombre}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Descripción</label>
          <div class="col-sm-10">
            <textarea
              className="form-control"
              name="descripcion"
              value={testData.descripcion}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Asignado a</label>
          <div class="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="assignedTo"
              value={testData.assignedTo}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Estado</label>
          <div class="col-sm-10">
            <select
              className="form-select"
              name="estado"
              value={testData.estado}
              onChange={handleChange}
              required
            >
              <option value="">Seleccionar...</option>
              <option value="Nuevo">Nuevo</option>
              <option value="En progreso">En progreso</option>
              <option value="Completado">Completado</option>
            </select>
          </div>
        </div>
        <input type="hidden" name="proyectos_id" value={projectId} />
        <div style={{ textAlign: "end" }}>
          <button type="submit" className="btn btn-primary">
            Crear
          </button>
        </div>
      </form>
    </>
  );
};

export default TestCreate;
